// Opens a saved marker drawn on the 2D map the way a click on it does: selects it and opens its info
// window (WEB-7109, for map deep links). render-markers draws clones of the store's markers, so the
// store never holds their map elements; it registers each one's click handler here instead.

const openers = new Map()

export const clearMarkerOpeners = () => openers.clear()

export const setMarkerOpener = (id, open) => openers.set(String(id), open)

// False when the marker isn't drawn (its type is hidden, or the renderer hasn't reached it yet).
export const openDrawnMarker = id => {
  const open = openers.get(String(id))
  if (!open) return false
  open()
  return true
}
